<template>
    <div class="table">
        <div class="height-percent-100">
            <el-table
                stripe
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :row-style="{ height: '38px' }"
                :header-cell-style="headCellStyle"
                :data="tableData"
                @selection-change="handleSelectionChange"
                height="100%"
                v-loading="loading"
            >
                <el-table-column type="selection" width="50" />

                <el-table-column v-for="(item, index) in filteredColumns" :key="index" :prop="item.index" :label="item.title" show-overflow-tooltip :width="item.width">
                    <!-- 有配置图标则进行显示 -->
                    <template v-if="item.icon || item.operation || item.process || item.format" #default="{ row }">
                        <template v-if="item.icon">
                            <span>
                                <!-- 只能这么用了  不能在模板上绑定for -->
                                <span v-for="(icon, index) in item.icon" :key="index">
                                    <!-- 优先寻找自定义的title属性 xxxConvert直接读取type属性 -->
                                    <i
                                        v-icon:theme="[`${icon.type}Convert`, row[icon.index]]"
                                        :class="icon.extClass"
                                        class="icon-hover"
                                        v-if="((!icon.power && row[icon.index] !== 'undefined') || (icon.power && icon.power.indexOf('sysAdmin') !== -1)) && row[item.index] != null"
                                        @click="icon.click ? icon.click(row) : undefined"
                                    >
                                    </i>
                                </span>
                            </span>
                            <span v-if="item.popover">
                                <el-popover placement="top-start" width="auto" trigger="hover">
                                    <component v-if="item.popover.component" :is="item.popover.component" v-bind="item.popover.attrs" :rowData="row"></component>
                                    <span slot="reference">
                                        <span>{{ row[item.index] }}</span>
                                    </span>
                                </el-popover>
                            </span>
                            <span v-else-if="!item.iconOnly">{{ row[item.index] }}</span>
                        </template>

                        <!-- 如果有operation属性 说明是操作列 -->
                        <template v-else-if="item.operation">
                            <div class="uk-flex uk-flex-center">
                                <span v-for="(op, opIndex) in item.operation" :key="opIndex">
                                    <!-- 操作按钮目前有两种类型 一种是可根据条件显示或隐藏的按钮
                  一种是带状态切换的按钮 根据字段来设置按钮当前的状态
                  通常用switch定义带状态的按钮
                -->
                                    <template v-if="op.type">
                                        <i
                                            :class="operation[op.type].icon"
                                            :title="op.title || $t(operation[op.type].title)"
                                            class="operation cursor-pointer"
                                            @click="clickCallback(row, op)"
                                            v-if="!op.show || !row[op.show.index] || row[op.show.index] == op.show.value"
                                        ></i>
                                    </template>
                                    <template v-else-if="op.switch">
                                        <i
                                            :class="operation[op.switch[row[op.index]].type].icon"
                                            :title="$t(operation[op.switch[row[op.index]].type].title)"
                                            class="operation cursor-pointer"
                                            @click="clickCallback(row, op)"
                                        ></i>
                                    </template>
                                </span>
                            </div>
                        </template>

                        <!-- 如果有process属性则需要进行预处理 -->
                        <template v-else-if="item.process">
                            <span>{{ item.process(row[item.index]) }}</span>
                        </template>

                        <template v-else-if="item.format">
                            <template v-if="item.format === 'datetime'">
                                <span>{{ $timetransition(row[item.index]) }}</span>
                            </template>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <Pagination class="pagination" :total="total" :page.sync="params[0].iDisplayStart" :limit.sync="params[0].iDisplayLength" v-if="getList" @pagination="getList"></Pagination>
    </div>
</template>

<script>
// 引入默认暴露 也就是全部转换工具类  随后根据传入的图标类型传入工具类
import operation from './config/operation';
import { _debounce } from '@/utils/common';

export default {
    name: 'stable',
    props: {
        columns: {
            type: Array,
            default: () => []
        },
        req: {
            type: Function,
            default: Promise.resolve()
        },
        params: {
            type: Array
        },
        process: {}
    },
    data() {
        return {
            tableData: null,
            operation,
            // 过滤后的列
            filteredColumns: [],
            total: 0,
            getList: null,
            loading: true
        };
    },
    watch: {
        columns: {
            immediate: true,
            handler() {
                this.filtrateColumns();
            }
        }
    },
    computed: {
        /** 用于表示当前登录用户属于什么类型的角色 */
        sysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            if (currentUser.sysScope && currentUser.sysAdmin) {
                // 系统管理员
                return 'isSysAdmin';
            } else if (currentUser.sysScope && !currentUser.sysAdmin) {
                // 系统非管理员
                return 'isSysNoAdmin';
            } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
                // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
                return 'noSysIsAdmin';
            } else {
                // 非系统非管理员
                return 'noSysNoAdmin';
            }
        }
    },
    methods: {
        reqList() {
            this.loading = true;
            this.req(...this.params)
                .then(res => {
                    const result = res.result;
                    this.tableData = this.process ? this.process(result.result) : result.result || result;
                    if (result.pageInfo) {
                        this.total = result.pageInfo.total;
                    } else if (res.pageInfo) {
                        this.total = res.pageInfo.total;
                    }
                })
                .finally(() => {
                    this.$nextTick(() => {
                        this.loading = false;
                    });
                });
        },
        // 过滤列数据
        filtrateColumns() {
            if (this.columns) {
                // 过滤权限数组
                this.filteredColumns = this.columns.filter(item => {
                    return item.power ? item.power.indexOf(this.sysAdmin) !== -1 : true;
                });
            }
        },
        // 当table被点击时会选择先执行这个回调
        clickCallback(row, btn) {
            if (btn.switch) {
                const status = row[btn.index];
                btn = btn.switch[status];
            }
            if (!btn.click) return;
            let promise = Promise.resolve();
            if (btn.tip) {
                if (typeof btn.tip === 'boolean' && btn.tip) promise = this.$confirm(this.$t(this.$t(btn.msg) || this.$t('public.tip_confirm')));
                else {
                    promise = this.$confirm(this.$t(btn.tip && btn.tip.content));
                }
            }

            promise
                .then(() => {
                    btn.click(row, btn);
                    // 加载配置 按需刷新
                    if (operation[btn.type].reflash) this.getList();
                })
                .catch(() => {});
        },
        // 当图标被点击
        iconClick(e) {
            const { target } = e;

            if (target.clickFn) {
                target.clickFn();
            }
        },
        handleSelectionChange(row) {
            this.$emit('selectData', row);
        }
    },

    mounted() {
        // 注意 ：getList暂时从外部调用 因为与v-search太耦合了
        this.getList = _debounce(this.reqList, 100);
    }
};
</script>

<style scoped lang="scss">
.table {
    height: calc(100% - 60px);
}

.operation {
    margin: 0 10px;
}

.pagination {
    padding-top: 0;
    padding-right: 15px !important;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
i.icon-hover {
    color: #ccc;
    &:hover {
        color: #344962;
        font-weight: bold;
    }
}
</style>
